var map = {
	"./000_insti.jpg": 141,
	"./000_insti_mobile.jpg": 142,
	"./00_gauchahoje.jpg": 143,
	"./00_gauchahoje_mobile.jpg": 144,
	"./01_central.jpg": 145,
	"./01_central_mobile.jpg": 146,
	"./02_supermanha.jpg": 147,
	"./02_supermanha_mobile.jpg": 148,
	"./03_variedades.jpg": 149,
	"./03_variedades_mobile.jpg": 150,
	"./04_gazetanoticias.jpg": 151,
	"./04_gazetanoticias_mobile.jpg": 152,
	"./05_gazetaesporte.jpg": 153,
	"./05_gazetaesporte_mobile.jpg": 154,
	"./06_salaredacao.jpg": 155,
	"./06_salaredacao_mobile.jpg": 156,
	"./07_topbandas.jpg": 157,
	"./07_topbandas_mobile.jpg": 158,
	"./08_ladoalado.jpg": 159,
	"./08_ladoalado_mobile.jpg": 160,
	"./09_vozdobrasil.jpg": 161,
	"./09_vozdobrasil_mobile.jpg": 162,
	"./10_showesportes.jpg": 163,
	"./10_showesportes_mobile.jpg": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;